// AddClientModal.jsx
import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';

function AddClientModal({ open, onClose, onSuccess }) {
    // Estados para los campos
    const [nombre, setNombre] = useState('');
    const [razonSocial, setRazonSocial] = useState('');
    const [lineaAsignada, setLineaAsignada] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    // Manejar el guardado
    const handleSave = async () => {
        try {
            // Validar
            if (!nombre.trim()) {
                setErrorMsg('El nombre es obligatorio');
                return;
            }

            // Petición POST
            const response = await fetch('TU_ENDPOINT_API', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    nombre,
                    razonSocial,
                    lineaAsignada,
                }),
            });

            if (!response.ok) {
                throw new Error('Error al crear cliente');
            }

            // Si se creó bien
            // (Opcional) notificar al padre que refresque la lista
            if (onSuccess) {
                onSuccess();
            }

            // Cerrar el modal
            onClose();

            // Limpiar campos (opcional)
            setNombre('');
            setRazonSocial('');
            setLineaAsignada('');
            setErrorMsg('');

        } catch (error) {
            console.error(error);
            setErrorMsg(error.message || 'Error desconocido');
        }
    };

    // Manejar cierre
    const handleClose = () => {
        // Limpiar si quieres
        setErrorMsg('');
        setNombre('');
        setRazonSocial('');
        setLineaAsignada('');
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-add-client-title"
            aria-describedby="modal-add-client-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: '#fff',
                    p: 4,
                    boxShadow: 24,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" id="modal-add-client-title">
                    Agregar Cliente
                </Typography>
                <Typography variant="body2" id="modal-add-client-description" sx={{ mb: 2 }}>
                    Completa los datos para crear un nuevo cliente
                </Typography>

                {errorMsg && (
                    <Typography variant="body2" sx={{ color: 'red', mb: 2 }}>
                        {errorMsg}
                    </Typography>
                )}

                <TextField
                    label="Nombre"
                    variant="outlined"
                    required
                    sx={{ mb: 2 }}
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                />
                <TextField
                    label="Razón Social"
                    variant="outlined"
                    sx={{ mb: 2 }}
                    value={razonSocial}
                    onChange={(e) => setRazonSocial(e.target.value)}
                />
                <TextField
                    label="Línea Asignada"
                    variant="outlined"
                    sx={{ mb: 2 }}
                    value={lineaAsignada}
                    onChange={(e) => setLineaAsignada(e.target.value)}
                />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button variant="outlined" color="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSave}>
                        Guardar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

export default AddClientModal;
